<template>
  <v-app-bar color="primary" dark clipped-left dense app flat>
    <v-row>
      <v-col class="pa-0 nav-left-buttons" cols="4">
        <v-layout>
          <v-tooltip bottom persistent>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                tile
                :class="
                  drawer.type == 'page-navigation'
                    ? 'secondary nav-button-active'
                    : ''
                "
                :readonly="drawer.type == 'page-navigation'"
                @click.stop="
                  openEditor({
                    type: 'page-navigation'
                  })
                "
              >
                <v-icon>mdi-format-list-bulleted</v-icon>
              </v-btn>
            </template>
            <span>Manage pages and navigation</span>
          </v-tooltip>

          <v-divider vertical></v-divider>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                tile
                :class="
                  drawer.type == 'section-builder'
                    ? 'secondary nav-button-active'
                    : ''
                "
                :readonly="drawer.type == 'section-builder'"
                @click.stop="
                  openEditor({
                    type: 'section-builder',
                    size: 'md'
                  })
                "
              >
                <v-icon fill="white" style="width: 16">$builder</v-icon>
              </v-btn>
            </template>
            <span>Add and sort sections</span>
          </v-tooltip>

          <v-divider vertical></v-divider>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                tile
                :class="
                  drawer.type == 'section-editor'
                    ? 'secondary nav-button-active'
                    : ''
                "
                :readonly="drawer.type == 'section-editor'"
                @click.stop="
                  openEditor({
                    type: 'section-editor'
                  })
                "
              >
                <v-icon fill="white" style="width: 18">$edit</v-icon>
              </v-btn>
            </template>
            <span>Edit sections</span>
          </v-tooltip>

          <v-divider vertical></v-divider>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                tile
                :class="
                  drawer.type == 'media-manager'
                    ? 'secondary nav-button-active'
                    : ''
                "
                :readonly="drawer.type == 'media-manager'"
                @click.stop="
                  openEditor({
                    type: 'media-manager',
                    size: 'lg'
                  })
                "
              >
                <v-icon fill="white" style="width: 18">$media</v-icon>
              </v-btn>
            </template>
            <span>Manage media</span>
          </v-tooltip>

          <v-divider vertical></v-divider>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                tile
                :class="
                  drawer.type == 'template-settings'
                    ? 'secondary nav-button-active'
                    : ''
                "
                :readonly="drawer.type == 'template-settings'"
                @click.stop="
                  openEditor({
                    type: 'template-settings'
                  })
                "
              >
                <v-icon>mdi-palette-outline</v-icon>
              </v-btn>
            </template>
            <span>Manage global template settings</span>
          </v-tooltip>

          <v-divider vertical></v-divider>

          <!-- TODO - Add manage all pages  
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon tile @click.stop>
                <v-icon>mdi-tune-vertical</v-icon>
              </v-btn>
            </template>
            <span>Manage sections on all pages</span>
          </v-tooltip>

          <v-divider vertical></v-divider>-->
        </v-layout>
      </v-col>

      <v-col class="pa-0 nav-center-buttons" cols="4">
        <editor-screen-mode-toggle></editor-screen-mode-toggle>
      </v-col>

      <v-col class="pa-0 nav-right-buttons" cols="4">
        <v-layout>
          <v-spacer></v-spacer>

          <v-menu offset-y left>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" tile text height="48">
                <v-icon left>mdi-account-circle-outline</v-icon>
                {{ currentUser.name }}
                <v-icon small right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item link>
                <v-list-item-title>Configuration</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <logout-menu-item></logout-menu-item>
            </v-list>
          </v-menu>

          <!-- <v-btn tile text height="48">
            <v-icon left>mdi-account-circle-outline</v-icon>
            {{ currentUser.name }}
            <v-icon small right>mdi-chevron-down</v-icon>
          </v-btn>

          <v-divider vertical></v-divider>

          <logout-button icon tile>
            <v-icon>mdi-logout</v-icon>
          </logout-button>-->
        </v-layout>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import LogoutMenuItem from '@/components/auth/LogoutMenuItem'
import EditorScreenModeToggle from '@/components/editor/EditorScreenModeToggle'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'EditorNavigationBar',
  components: {
    LogoutMenuItem,
    EditorScreenModeToggle
  },
  computed: {
    ...mapState('editor', ['drawer'])
  },
  methods: {
    ...mapActions('editor', ['openEditor'])
  }
}
</script>

<style>
.v-app-bar.v-app-bar--fixed {
  z-index: 200;
}
.theme--dark.v-btn.nav-button-active .v-icon {
  color: #ffffff !important;
}

.v-btn.nav-button-active {
  position: relative;
}

.v-btn.nav-button-active::after {
  content: '';
  position: absolute;
  z-index: 999;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #fff;
}

.nav-center-buttons .v-btn.nav-button-active::after,
.nav-right-buttons .v-btn.nav-button-active::after {
  border-bottom-color: #eff3f6;
}
</style>
